import React, { createContext, memo, useReducer } from 'react';
import { accountReducer } from './accountReducer';
export var defaultAccountState = {
    isFetching: false,
    error: null,
    uid: '',
    role: 'reader',
    language: 'cz',
    disabled: false
};
var store = createContext({
    account: defaultAccountState,
    dispatchAccount: function () {
    }
});
var Provider = store.Provider;
export var useAccount = function () { return React.useContext(store); };
export var AccountProvider = memo(function (_a) {
    var children = _a.children;
    var _b = useReducer(accountReducer, defaultAccountState), account = _b[0], dispatchAccount = _b[1];
    return (React.createElement(Provider, { value: { account: account, dispatchAccount: dispatchAccount } }, children));
});
